import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from "vue-router";
import CKEditor from '@ckeditor/ckeditor5-vue';

Vue.use(CKEditor);

Vue.config.productionTip = false

import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader

// router setup
import routes from "./routes/routes";

import store from "./store";
import ApiService from "./utils/api.service";
ApiService.init(store);

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});


// Ensure we checked auth before each page load.
router.beforeEach((to, _from, next) => {
  Promise.all([store.dispatch("auth/check_auth")]);
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters["auth/isAuthenticated"]) {
      next();
    } else {
      next({
        path: "/login"
      });
    }
  } else {
    next();
  }
});

require('./plugins/vue-html5-editor');

import formatHelpers from './utils/format.helper';
import assetsHelpers from './utils/assets.helper';

const helpers = {
  install(Vue) {
    Vue.prototype.$format = formatHelpers; // we use $ because it's the Vue convention
    Vue.prototype.$assets = assetsHelpers; // we use $ because it's the Vue convention
  }
};

Vue.use(helpers);


new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
